module.exports = __webpack_public_path__ + "img/NeuePlak-CompBold.4c8096fe.svg";